import { render } from "./VStep.vue?vue&type=template&id=7dc8afe8&scoped=true"
import script from "./VStep.vue?vue&type=script&lang=js"
export * from "./VStep.vue?vue&type=script&lang=js"

import "./VStep.vue?vue&type=style&index=0&id=7dc8afe8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7dc8afe8"]])

export default __exports__